import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext();

export const translations = {
  en: {
    nav: {
      home: "Home",
      solutions: "Solutions",
      about: "About Us",
      oursciences: "Our Science",
      facilities: "Facilities",
      testimonials: "Testimonials",
      career: "Career",
      contact: "Contact",
      contactUs: "Contact Us",
    },
    common: {
      findSolution: "Find Your Solution",
      seeFullProcess: "See Our Process",
      exploreSolutions: "Explore Our Solutions",
      talkToTeam: "Talk to our team",
      chatWhatsapp: "Chat on WhatsApp",
      sendMessage: "Send Us a Message",
      learnMore: "Learn more",
      readMore: "Read more",
      viewProduct: "View product",
      downloadCatalogue: "Download Full Catalogue",
      back: "Back",
      allRightsReserved: "All rights reserved.",
    },
    home: {
      heroLine1: "Grow More.",
      heroLine2: "Harm Less.",
      heroLine3: "With Microbes.",
      heroSub: "We help farmers do it — with Bio Solutions developed from 120+ proprietary microbial strains, built for tropical agriculture.",
      trustEyebrow: "Proven at scale",
      certsTitle: "Certified & independently verified",
      solutionsEyebrow: "What we make",
      solutionsTitle: "Solutions built from living microbes",
      solutionsSub: "Three core families of biological inputs, developed end-to-end in our own labs.",
      discoveryEyebrow: "From Discovery to Your Field",
      discoveryTitle: "From nature to field",
      discoverySub: "Every strain starts as a wild discovery — then goes through a rigorous, lab-validated process before it ever reaches a farm.",
      testimonialsEyebrow: "Cerita Tani",
      testimonialsTitle: "Trusted by farmers across Indonesia",
      ctaTitle: "Ready to grow more, and harm less?",
      ctaSub: "Talk to our team about the right solution for your farm or plantation.",
    },
    stats: {
      founded: "Year Founded",
      isolates: "Microbial Isolated",
      provinces: "Provinces Served",
      farmers: "Farmer Partners",
    },
    steps: {
      bioprospecting: "Bioprospecting",
      bioprospectingDesc: "Found in the wild — soil, hot springs, plant tissue.",
      stabilization: "Stabilization",
      stabilizationDesc: "ANHYDRIOM™ keeps microbes dormant and potent — shelf-stable 3+ years.",
      deploy: "Deploy",
      deployDesc: "Reaching 15,000+ farms across 16+ provinces.",
    },
    solutions: {
      title: "Find Your Microbes",
      intro: "Every product here started as a microbe isolated from nature, then went through our own labs before it ever reached a field. Filter by what you're growing, or by the problem you're solving.",
      searchPlaceholder: "Search by product name, active organism, crop, or pest/disease…",
      searchButton: "Search",
      filterType: "Solution type",
      filterCrop: "Crop",
      all: "All",
      clear: "Clear filters",
      empty: "No products match that combination yet. Try a different crop or solution type, or talk to our team for a recommendation.",
      catalogueTitle: "Want the full range in one file?",
      catalogueSub: "Download the complete Prima Agro Tech catalogue, or talk to our team about what fits your farm or plantation.",
      resultsCount: "products",
      seeMore: "See More",
      types: {
        "Bio Fertilizer": "Bio Fertilizer",
        "Bio Insecticide": "Bio Insecticide",
        "Bio Fungicide": "Bio Fungicide",
        "Bio Stimulant & Nutrition": "Bio Stimulant & Nutrition",
        "Bio Decomposer": "Bio Decomposer",
      },
      crops: {
        "Paddy": "Paddy",
        "Corn": "Corn",
        "Chilli": "Chilli",
        "Tomato": "Tomato",
        "Potato": "Potato",
        "Shallot": "Shallot",
        "Oil Palm": "Oil Palm",
        "Sugarcane": "Sugarcane",
        "Banana": "Banana",
        "Durian": "Durian",
        "Cacao": "Cacao",
        "Citrus": "Citrus",
        "Avocado": "Avocado",
        "Cabbage": "Cabbage",
        "Cucumber": "Cucumber",
        "Dragon Fruit": "Dragon Fruit",
        "Edamame": "Edamame",
        "Melon": "Melon",
        "Patchouli": "Patchouli",
        "Radish": "Radish",
        "Watermelon": "Watermelon",
      },
    },
    product: {
      keyBenefits: "Key Benefits",
      whatItDoes: "What it does",
      formulation: "Formulation",
      application: "Application guide",
      trials: "Field trial data",
      certifications: "Certifications & registration",
      downloads: "Downloads",
      related: "Related solutions",
      relatedSub: "Other products suited to the same crop.",
      ctaTitle: "Have a question about",
      ctaSub: "Our team can help you find the right dosage and application plan for your farm or plantation.",
      targetCrops: "Target crops",
      regNo: "Registration no.",
      renewalTag: "Renewal in progress",
      certOrganikDesc: "Indonesian National Organic Certification",
      certControlUnionDesc: "USDA / International Organic Certification",
      brochure: "Download Product Brochure (PDF)",
      catalogue: "Download Full Catalogue (PDF)",
      slideTable: "← Slide table →",
    },
    about: {
      eyebrow: "About Us",
      title: "A decade of commitment to regenerative agriculture",
      intro: "Microbial specialist, born in Indonesia, built for tropical agriculture — with an in-house process from bioprospecting to deployment.",
      journeyEyebrow: "Our Journey",
      journeyTitle: "Working for agriculture since 2008",
      reachEyebrow: "Our Reach",
      reachTitle: "A footprint that keeps growing",
      provincesServed: "Provinces served",
      plantationsServed: "Plantations served",
      farmerPartners: "Farmer partners",
      findSolutionCta: "Find Your Solution",
    },
    sciences: {
      eyebrow: "Our Sciences",
      title: "From Nature to Fields",
      intro: "Every Prima Agro Tech product starts as a wild discovery — a microbe found in Indonesian soil, a volcanic hot spring, or a plant fighting off disease on its own. Before it ever reaches a farm, it passes through a rigorous six-stage process. Here's how.",
      closingTitle: "See how Anhydriom powers every product in our lineup",
      closingCta: "Explore Our Solutions",
      marquee: "ORIGIN · RIGOUR · TRACK RECORD ·",
    },
    facilities: {
      eyebrow: "Facilities",
      title: "Two Facilities, One Standard",
      intro: "Prima Agro Tech operates two facilities in Indonesia: our head office in Penjaringan, Jakarta, and a dedicated laboratory and production facility in Karawaci, Tangerang, Banten — where every product is developed, tested, and manufactured in-house.",
      overviewBody: "Each of our facilities is designed with a single goal in mind: to ensure consistent quality from research through production. In Penjaringan, our team develops strategies and supports our farmer partners in the field. In Karawaci, every strain is tested, formulated, and produced in accordance with strict quality standards.",
      labTitle: "From Research to Solutions",
      lab: "Our laboratory has evolved alongside the company's growth, with facility upgrades in 2015 and 2018 and ISO 17025:2017 accreditation in 2024. This is where each strain is isolated, molecularly identified, and formulated before undergoing field testing.",
      prodTitle: "Built to Scale",
      prod: "Our in-house production facility handles every step of the process, from raw formulation to finished sachets, with a capacity of more than 1 million sachets. This supports distribution across 16+ provinces and growing export markets throughout Southeast Asia.",
      closing: "See how we build our products",
      accreditationsTitle: "Accreditations & Quality Standards",
      accreditationsSubtitle: "Our testing laboratory and production operations meet certified national and international standards.",
      kanTitle: "Komite Akreditasi Nasional (KAN)",
      kanNumber: "Accreditation No. LP-1789-IDN",
      kanDesc: "Accredited testing laboratory in accordance with ISO/IEC 17025.",
      iso17025Title: "ISO/IEC 17025:2017",
      iso17025Subtitle: "Testing & Calibration Laboratories Competence",
      iso17025Desc: "Certified laboratory competency for analytical testing and microbiological validation.",
      iso9001Title: "ISO 9001:2015",
      iso9001Subtitle: "TÜV SÜD Certified",
      iso9001Desc: "International Standard for Consistent Quality Management",
      viewCert: "View Certificate",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "Real Stories from the Field",
      intro: "What farmers, distributors, and plantations say about our products, season after season.",
      formTitle: "Submit your story with our products",
      formSub: "Used a Prima Agro Tech product? Tell us how it performed — your story may be featured here.",
      fullName: "Full name",
      role: "Role",
      crop: "Crop",
      province: "Province",
      productUsed: "Product used",
      yourStory: "Your story",
      submit: "Submit your story",
      thanks: "Thank you — your story has been received.",
      roles: {
        farmer: "Farmer",
        distributor: "Distributor",
        store: "Store",
        plantation: "Plantation",
        institution: "Institution",
      },
    },
    career: {
      eyebrow: "Career",
      title: "The team behind every bag",
      intro: "Prima Agro Tech's work happens in two places: in the lab, where every strain is discovered and developed, and in the field, where our team makes sure it actually works for the farmers using it.",
      fieldTitle: "In the Field",
      field: "Our field agents don't disappear after a sale. They visit farms and plantations directly — training on correct dosage and application, troubleshooting problems as they come up, and making sure every product performs the way it did in trials. It's a large part of why 15,000+ farmers keep coming back.",
      labTitle: "In the Lab",
      lab: "Behind every product is a team running expeditions across Indonesian islands, isolating and identifying new strains, and testing formulations long before they reach a farm. It's slow, exacting work — and it's why our products hold up under real field conditions, not just lab conditions.",
      cta: "Want to see more of what our team does day to day? Follow us on LinkedIn",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk",
      intro: "Whether you're a distributor evaluating our range, a plantation assessing fit, or a farmer with a specific problem — our team is ready to help.",
      name: "Full name",
      email: "Email address",
      company: "Company (optional)",
      phone: "Phone (optional)",
      message: "Message",
      send: "Send Message",
      sending: "Sending…",
      success: "Thank you — we'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
      officeTitle: "Head Office",
      office: "Penjaringan, Jakarta, Indonesia",
      labTitle: "Lab & Production",
      lab: "Karawaci, Tangerang, Banten, Indonesia",
      whatsappTitle: "WhatsApp",
      followTitle: "Follow us",
    },
    footer: {
      tagline: "Grow More. Harm Less. With Microbes.",
      company: "Company",
      explore: "Explore",
      legal: "Proprietary microbial bio-solutions, developed end-to-end in-house since 2008.",
    },
  },
  id: {
    nav: {
      home: "Beranda",
      solutions: "Solusi",
      about: "Tentang Kami",
      oursciences: "Ilmu Kami",
      facilities: "Fasilitas",
      testimonials: "Testimoni",
      career: "Karier",
      contact: "Kontak",
      contactUs: "Hubungi Kami",
    },
    common: {
      findSolution: "Temukan Solusi Anda",
      seeFullProcess: "Pelajari Proses Kami",
      exploreSolutions: "Jelajahi Solusi Kami",
      talkToTeam: "Hubungi tim kami",
      chatWhatsapp: "Chat via WhatsApp",
      sendMessage: "Kirim Pesan",
      learnMore: "Selengkapnya",
      readMore: "Baca selengkapnya",
      viewProduct: "Lihat produk",
      downloadCatalogue: "Unduh Katalog Lengkap",
      back: "Kembali",
      allRightsReserved: "Hak cipta dilindungi.",
    },
    home: {
      heroLine1: "Grow More.",
      heroLine2: "Harm Less.",
      heroLine3: "With Microbes.",
      heroSub: "Kami membantu petani mewujudkannya — dengan solusi pertanian dari 120+ strain mikroba unggulan.",
      trustEyebrow: "Terbukti dalam skala besar",
      certsTitle: "Tersertifikasi & terverifikasi independen",
      solutionsEyebrow: "Yang kami buat",
      solutionsTitle: "Solusi dari mikroba hidup",
      solutionsSub: "Tiga jenis input hayati, dikembangkan menyeluruh di laboratorium kami sendiri.",
      discoveryEyebrow: "Dari Penemuan ke Lahan Anda",
      discoveryTitle: "Dari alam ke lahan",
      discoverySub: "Setiap strain mikroba ditemukan di alam — lalu melewati proses ketat yang tervalidasi di laboratorium sebelum sampai ke lahan.",
      testimonialsEyebrow: "Cerita Tani",
      testimonialsTitle: "Dipercaya petani di seluruh Indonesia",
      ctaTitle: "Ready to grow more, and harm less?",
      ctaSub: "Bicarakan solusi yang tepat untuk lahan atau perkebunan Anda dengan tim kami.",
    },
    stats: {
      founded: "Tahun Berdiri",
      isolates: "Isolat Mikroba",
      provinces: "Provinsi Terlayani",
      farmers: "Mitra Petani",
    },
    steps: {
      bioprospecting: "Bioprospeksi",
      bioprospectingDesc: "Ditemukan di alam — tanah, mata air panas, jaringan tanaman.",
      stabilization: "Stabilisasi",
      stabilizationDesc: "ANHYDRIOM™ menjaga mikroba dorman dan potensial — stabil disimpan 3+ tahun.",
      deploy: "Distribusi",
      deployDesc: "Menjangkau 15.000+ lahan di 16+ provinsi.",
    },
    solutions: {
      title: "Temukan Mikroba Anda",
      intro: "Setiap produk berawal dari mikroba asal alam Indonesia, lalu melewati proses pengembangan internal kami sebelum sampai ke lahan. Saring berdasarkan tanaman Anda, atau masalah yang ingin diselesaikan.",
      searchPlaceholder: "Cari nama produk, organisme aktif, tanaman, atau hama/penyakit…",
      searchButton: "Cari",
      filterType: "Jenis solusi",
      filterCrop: "Tanaman",
      all: "Semua",
      clear: "Hapus filter",
      empty: "Belum ada produk yang cocok. Coba kombinasi lain, atau hubungi tim kami untuk rekomendasi.",
      catalogueTitle: "Ingin seluruh rangkaian dalam satu file?",
      catalogueSub: "Unduh katalog lengkap Prima Agro Tech, atau bicarakan dengan tim kami produk yang cocok untuk lahan Anda.",
      resultsCount: "produk",
      seeMore: "Lihat Lebih Banyak",
      types: {
        "Bio Fertilizer": "Pupuk Hayati",
        "Bio Insecticide": "Bio Insektisida",
        "Bio Fungicide": "Bio Fungisida",
        "Bio Stimulant & Nutrition": "Bio Stimulan & Nutrisi",
        "Bio Decomposer": "Bio Dekomposer",
      },
      crops: {
        "Paddy": "Padi",
        "Corn": "Jagung",
        "Chilli": "Cabai",
        "Tomato": "Tomat",
        "Potato": "Kentang",
        "Shallot": "Bawang Merah",
        "Oil Palm": "Kelapa Sawit",
        "Sugarcane": "Tebu",
        "Banana": "Pisang",
        "Durian": "Durian",
        "Cacao": "Kakao",
        "Citrus": "Jeruk",
        "Avocado": "Alpukat",
        "Cabbage": "Kubis",
        "Cucumber": "Mentimun",
        "Dragon Fruit": "Buah Naga",
        "Edamame": "Edamame",
        "Melon": "Melon",
        "Patchouli": "Nilam",
        "Radish": "Lobak",
        "Watermelon": "Semangka",
      },
    },
    product: {
      keyBenefits: "Keunggulan & Manfaat",
      whatItDoes: "Cara kerja",
      formulation: "Formulasi",
      application: "Panduan aplikasi",
      trials: "Data uji lapangan",
      certifications: "Sertifikasi & registrasi",
      downloads: "Unduhan",
      related: "Solusi terkait",
      relatedSub: "Produk lain yang cocok untuk tanaman yang sama.",
      ctaTitle: "Ada pertanyaan tentang",
      ctaSub: "Tim kami dapat membantu menemukan dosis dan rencana aplikasi yang tepat untuk lahan Anda.",
      targetCrops: "Tanaman sasaran",
      regNo: "No. registrasi",
      renewalTag: "Dalam proses perpanjangan",
      certOrganikDesc: "Sertifikasi Standar Organik Nasional Indonesia",
      certControlUnionDesc: "Sertifikasi Standar Organik USDA / Internasional",
      brochure: "Unduh Brosur Produk (PDF)",
      catalogue: "Unduh Katalog Lengkap (PDF)",
      slideTable: "← Geser tabel →",
    },
    about: {
      eyebrow: "Tentang Kami",
      title: "Komitmen satu dekade pada pertanian regeneratif",
      intro: "Spesialis mikroba, lahir di Indonesia, dirancang untuk pertanian tropis — melalui proses internal, dari Bioprospeksi hingga Distribusi.",
      journeyEyebrow: "Perjalanan Kami",
      journeyTitle: "Berkarya untuk pertanian sejak 2008",
      reachEyebrow: "Jangkauan Kami",
      reachTitle: "Jejak yang terus bertumbuh",
      provincesServed: "Provinsi terlayani",
      plantationsServed: "Perkebunan dilayani",
      farmerPartners: "Mitra petani",
      findSolutionCta: "Temukan Solusi Anda",
    },
    sciences: {
      eyebrow: "Ilmu Kami",
      title: "Dari Alam ke Lahan",
      intro: "Setiap produk Prima Agro Tech berasal dari alam liar - Mikroba ditemukan melalui tanah di Indonesia, mata air panas vulkanik, atau tanaman yang melawan penyakitnya sendiri. Terproses secara ketat melalui enam tahap. Inilah caranya.",
      closingTitle: "Temukan bagaimana ANHYDRIOM™ menjadi kekuatan di balik setiap produk kami",
      closingCta: "Temukan Solusi Anda",
      marquee: "ASAL-USUL · KETELITIAN · REKAM JEJAK ·",
    },
    facilities: {
      eyebrow: "Fasilitas",
      title: "Dua Fasilitas, Satu Standar",
      intro: "Prima Agro Tech memiliki dua fasilitas di Indonesia: kantor pusat di Penjaringan, Jakarta, serta laboratorium dan fasilitas produksi di Karawaci, Tangerang. Seluruh produk kami dikembangkan, diuji, dan diproduksi secara in-house.",
      overviewBody: "Setiap fasilitas kami dirancang untuk satu tujuan: memastikan konsistensi mutu dari riset hingga produksi. Di Penjaringan, tim kami merancang strategi dan mendukung mitra petani di lapangan. Di Karawaci, setiap strain diuji, diformulasikan, dan diproduksi di bawah standar mutu yang ketat.",
      labTitle: "Dari Riset ke Solusi",
      lab: "Laboratorium kami berkembang seiring pertumbuhan perusahaan, dengan peningkatan fasilitas pada 2015 dan 2018 serta akreditasi ISO 17025:2017 pada 2024. Di sinilah setiap strain diisolasi, diidentifikasi secara molekuler, dan diformulasikan sebelum melalui uji lapangan.",
      prodTitle: "Siap untuk Skala Besar",
      prod: "Fasilitas produksi internal kami menangani setiap tahap proses, mulai dari formulasi bahan baku hingga kemasan sachet jadi, dengan kapasitas lebih dari 1 juta sachet. Hal ini mendukung distribusi ke lebih dari 16 provinsi serta pasar ekspor yang terus berkembang di seluruh Asia Tenggara.",
      closing: "Lihat bagaimana kami membuat produk",
      accreditationsTitle: "Akreditasi & Standar Mutu",
      accreditationsSubtitle: "Laboratorium pengujian dan fasilitas produksi kami memenuhi standar nasional dan internasional yang telah tersertifikasi.",
      kanTitle: "Komite Akreditasi Nasional (KAN)",
      kanNumber: "No. Akreditasi LP-1789-IDN",
      kanDesc: "Laboratorium pengujian terakreditasi sesuai dengan ISO/IEC 17025.",
      iso17025Title: "ISO/IEC 17025:2017",
      iso17025Subtitle: "Kompetensi Laboratorium Pengujian & Kalibrasi",
      iso17025Desc: "Kompetensi laboratorium bersertifikat untuk pengujian analitik dan validasi mikrobiologis.",
      iso9001Title: "ISO 9001:2015",
      iso9001Subtitle: "Tersertifikasi oleh TÜV SÜD",
      iso9001Desc: "Standar Internasional untuk Manajemen Kualitas yang Konsisten",
      viewCert: "Lihat Sertifikat",
    },
    testimonials: {
      eyebrow: "Testimoni",
      title: "Kisah Nyata dari Lapangan",
      intro: "Apa kata petani, distributor, dan perkebunan yang menggunakan produk kami waktu ke waktu?",
      formTitle: "Kirim cerita Anda dengan produk kami",
      formSub: "Pernah memakai produk Prima Agro Tech? Ceritakan hasilnya — kisah Anda bisa ditampilkan di sini.",
      fullName: "Nama lengkap",
      role: "Peran",
      crop: "Tanaman",
      province: "Provinsi",
      productUsed: "Produk yang digunakan",
      yourStory: "Cerita Anda",
      submit: "Kirim cerita Anda",
      thanks: "Terima kasih — cerita Anda telah kami terima.",
      roles: {
        farmer: "Petani",
        distributor: "Distributor",
        store: "Toko",
        plantation: "Perkebunan",
        institution: "Institusi",
      },
    },
    career: {
      eyebrow: "Karier",
      title: "Tim di balik setiap kemasan",
      intro: "Dari laboratorium hingga lapangan, Prima Agro Tech mengembangkan setiap strain dan memastikan produknya memberikan hasil nyata bagi petani.",
      fieldTitle: "Di Lapangan",
      field: "Tim lapangan kami tidak berhenti setelah penjualan. Mereka hadir langsung di lahan dan perkebunan untuk memberikan panduan dosis dan aplikasi yang tepat, membantu mengatasi kendala di lapangan, serta memastikan setiap produk bekerja sesuai hasil pengujian. Pendampingan inilah yang membuat 15.000+ petani terus mempercayai dan menggunakan produk kami.",
      labTitle: "Di Laboratorium",
      lab: "Di balik setiap produk kami adalah proses yang panjang dan teliti — mulai dari menemukan strain baru di berbagai wilayah Indonesia hingga menguji formulasi di lapangan. Proses inilah yang memastikan setiap produk siap menghadapi kondisi nyata.",
      cta: "Ingin melihat lebih banyak keseharian tim kami? Ikuti kami di LinkedIn",
    },
    contact: {
      eyebrow: "Kontak",
      title: "Mari bicara",
      intro: "Baik Anda distributor yang menilai rangkaian kami, perkebunan yang mengevaluasi kesesuaian, atau petani dengan masalah spesifik — tim kami siap membantu.",
      name: "Nama lengkap",
      email: "Alamat email",
      company: "Perusahaan (opsional)",
      phone: "Telepon (opsional)",
      message: "Pesan",
      send: "Kirim Pesan",
      sending: "Mengirim…",
      success: "Terima kasih — kami akan segera menghubungi Anda.",
      error: "Terjadi kesalahan. Silakan coba lagi.",
      officeTitle: "Kantor Pusat",
      office: "Penjaringan, Jakarta, Indonesia",
      labTitle: "Lab & Produksi",
      lab: "Karawaci, Tangerang, Banten, Indonesia",
      whatsappTitle: "WhatsApp",
      followTitle: "Ikuti kami",
    },
    footer: {
      tagline: "Grow More. Harm Less. With Microbes.",
      company: "Perusahaan",
      explore: "Jelajahi",
      legal: "Input mikroba unggulan, dikembangkan dari hulu ke hilir secara internal sejak 2008.",
    },
  },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pat_lang") || "en");
  useEffect(() => {
    localStorage.setItem("pat_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (path, fallback) => {
    if (!path) return fallback || "";
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      cur = cur?.[p];
      if (cur === undefined) break;
    }
    if (cur !== undefined) return cur;

    // Fallback to EN if in another language
    if (lang !== "en") {
      let enCur = translations.en;
      for (const p of parts) {
        enCur = enCur?.[p];
        if (enCur === undefined) break;
      }
      if (enCur !== undefined) return enCur;
    }

    if (fallback !== undefined) return fallback;
    // Return last segment if it looks like a namespaced key, avoiding raw key prefixes in the UI
    return parts.length > 1 ? parts[parts.length - 1] : path;
  };
  const toggle = () => setLang((l) => (l === "en" ? "id" : "en"));
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
